import React, { PureComponent } from 'react'
import { string, number, bool, object, func, arrayOf } from 'prop-types'
import { Text, SvgGrid, PreRacePerformanceLine } from 'components'
import { getCurrentPriceUnit, getTotalPrice } from 'utils/prices'
import { priceFormatted } from 'utils/string'
import { translate } from 'react-i18next'
import { PreRaceCard } from './PreRaceCard'

const svgViewBox = '0 0 145 67'
const viewBox = { x: 28.7, y: 0.5, width: 115.8, height: 58.3 }

@translate()
export class PitStopsCard extends PureComponent {
    static propTypes = {
        groupId: string.isRequired,
        typeId: string.isRequired,
        units: number.isRequired,
        maxUnits: number,
        unitsLeft: number.isRequired,
        prices: arrayOf(number).isRequired,
        availableCredits: number.isRequired,
        className: string,
        onSetUnits: func.isRequired,
        showAMToolPanel: bool.isRequired,
        onToggleAMToolPanel: func,
        curveParams: object.isRequired,
        performanceMax: number.isRequired,
        expectedAssetLife: number.isRequired,
        circuitLength: number.isRequired,
        allowPurchaseUnitsInDebt: bool.isRequired,
        priceInDebt: number.isRequired,
        unitsLeftAsNormalPrice: number.isRequired
    }

    static defaultProps = {
        units: 0,
        maxUnits: 999999,
        prices: [],
        availableCredits: 999999
    }

    componentWillMount() {
        this.refreshData(this.props)
    }
    componentWillReceiveProps(nextProps) {
        this.refreshData(nextProps)
    }

    refreshData = props => {
        const { units, unitsLeft, prices, expectedAssetLife, circuitLength, priceInDebt, unitsLeftAsNormalPrice } = props
        this.price = units <= unitsLeft ? 0 : getCurrentPriceUnit(prices, units - unitsLeft, priceInDebt, unitsLeftAsNormalPrice)
        this.totalPrice = units <= unitsLeft ? 0 : getTotalPrice(prices, units - unitsLeft, priceInDebt, unitsLeftAsNormalPrice)
        this.distanceBetweenPitStops = (circuitLength / (units + 1)) / expectedAssetLife
    }

    renderAMToolPanel = () => {
        const { onToggleAMToolPanel, curveParams, performanceMax, expectedAssetLife, t } = this.props
        return (
            <div onClick={onToggleAMToolPanel}>
                <Text className="ChartLegend Y">{t('game.PRE_RACE.panelAMToolLineChartYLabel')}</Text>
                <svg viewBox={svgViewBox}>
                    <SvgGrid
                        viewBox={viewBox}
                        zeroLabel="0"
                        xLabel={expectedAssetLife.toFixed(1)}
                        yLabel={performanceMax.toFixed(1)}
                        clipId="viewBoxClip"
                    />
                    <PreRacePerformanceLine
                        curveParams={curveParams}
                        outputViewBox={viewBox}
                        pointMarker={this.distanceBetweenPitStops}
                        dashLineMarker={this.distanceBetweenPitStops}
                        clipPath="url(#viewBoxClip)"
                    />
                </svg>
                <Text className="ChartLegend X">{t('game.PRE_RACE.panelAMToolLineChartXLabel')}</Text>
            </div>
        )
    }

    render() {
        const { units, curveParams, performanceMax, expectedAssetLife, onToggleAMToolPanel, circuitLength, t, tReady, ...otherProps } = this.props
        return (
            <PreRaceCard
                className="PitStopsCard"
                icon="pitstops"
                name="Stops"
                units={units}
                selected
                amToolContent={this.renderAMToolPanel()}
                {...otherProps}
            >
                <Text><small>{t('game.PRE_RACE.pitstops.title')}</small></Text>
                <div className="flex col-stretch mt-10p">
                    <div className="flex row-stretch-center">
                        <Text>{t('game.PRE_RACE.pitstops.plannedCount')}: </Text>
                        <Text><small>{units}</small></Text>
                    </div>
                    <div className="flex row-stretch-center">
                        <Text>{t('game.PRE_RACE.pitstops.replacementCount')}: </Text>
                        <Text><small>{units + 1}</small></Text>
                    </div>
                    <div className="flex row-stretch-center">
                        <Text>{t('game.PRE_RACE.pitstops.cost')}: </Text>
                        <Text><small>{priceFormatted(this.price)}</small></Text>
                    </div>
                    <div className="flex row-stretch-center">
                        <Text>{t('game.PRE_RACE.pitstops.totalCost')}: </Text>
                        <Text><small>{priceFormatted(this.totalPrice)}</small></Text>
                    </div>
                </div>
            </PreRaceCard>
        )
    }
}



// WEBPACK FOOTER //
// src/components/Cards/PreRaceCard/PitStopsCard.js